const DB_NAME = 'BeCreativesFileCache';
const STORE_NAME = 'fileStore';
const DB_VERSION = 1;

import { Logger } from 'src/utils/logger';

let db: IDBDatabase | null = null;

export const initDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    if (db) {
      resolve(db);
      return;
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
      const database = (event.target as IDBOpenDBRequest).result;
      if (!database.objectStoreNames.contains(STORE_NAME)) {
        database.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = (event: Event) => {
      db = (event.target as IDBOpenDBRequest).result;
      resolve(db);
    };

    request.onerror = (event: Event) => {
      Logger.error('IndexedDB error:', 'IndexedDBService', (event.target as IDBOpenDBRequest).error);
      reject('Error opening IndexedDB.');
    };
  });
};

export const storeFile = async (id: string, file: File): Promise<void> => {
  const database = await initDB();
  return new Promise((resolve, reject) => {
    const transaction = database.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    const request = store.put(file, id);

    request.onsuccess = () => {
      resolve();
    };

    request.onerror = (event: Event) => {
      Logger.error('Error storing file:', 'IndexedDBService', (event.target as IDBRequest).error);
      reject('Error storing file in IndexedDB.');
    };
  });
};

export const getFile = async (id: string): Promise<File | null> => {
  const database = await initDB();
  return new Promise((resolve, reject) => {
    const transaction = database.transaction([STORE_NAME], 'readonly');
    const store = transaction.objectStore(STORE_NAME);
    const request = store.get(id);

    request.onsuccess = (event: Event) => {
      const file = (event.target as IDBRequest).result;
      resolve(file ? file : null);
    };

    request.onerror = (event: Event) => {
      Logger.error('Error getting file:', 'IndexedDBService', (event.target as IDBRequest).error);
      reject('Error getting file from IndexedDB.');
    };
  });
};

export const deleteFile = async (id: string): Promise<void> => {
  const database = await initDB();
  return new Promise((resolve, reject) => {
    const transaction = database.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    const request = store.delete(id);

    request.onsuccess = () => {
      resolve();
    };

    request.onerror = (event: Event) => {
      Logger.error('Error deleting file:', 'IndexedDBService', (event.target as IDBRequest).error);
      reject('Error deleting file from IndexedDB.');
    };
  });
};